import "../styles/footer-cta.css";
import CtaImage from "../images/cta-image.png";
import { useState } from "react";

function FooterCta() {
  const [email, setEmail] = useState("");

  return (
    <footer className="footer-cta">
      <img className="bg-image" alt="bg" src={CtaImage} />
      <div className="cta-div">
        <div className="cta-text">
          <h1>Get customized recommendations and pricing</h1>
          <p>Drop your email here and will send you more details</p>
        </div>
        <div className="cta-input">
          <input
            type="email"
            placeholder="Your email here"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
          <button>
            <p>Send Email</p>
            <div />
          </button>
        </div>
      </div>
    </footer>
  );
}

export default FooterCta;
